/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  learnMoreDeployZendeskClassic: generateDocsUrl(
    '/?topic=assistant-deploy-zendesk'
  ),
  learnMoreDeployZendeskNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-zendesk'
  ),
  learnMoreSalesforceAddPageClassic: generateDocsUrl(
    '/?topic=assistant-deploy-salesforce#deploy-salesforce-add-page-to-layout'
  ),
  learnMoreSalesforceAddPageNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-salesforce#deploy-salesforce-add-page-to-layout'
  ),
  learnMoreSalesforceDeploymentInfoClassic: generateDocsUrl(
    '/?topic=assistant-deploy-salesforce#deploy-salesforce-get-deployment-info'
  ),
  learnMoreSalesforceDeploymentInfoNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-salesforce#deploy-salesforce-get-deployment-info'
  ),
  learnMoreTransferSupportClassic: generateDocsUrl(
    '/?topic=assistant-deploy-web-chat#deploy-web-chat-dialog-prereq'
  ),
  learnMoreTransferSupportNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-web-chat#deploy-web-chat-dialog-prereq'
  ),
  learnMoreZendeskAccountKeyClassic: generateDocsUrl(
    '/?topic=assistant-deploy-zendesk#deploy-zendesk-get-account-key'
  ),
  learnMoreZendeskAccountKeyNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-zendesk#deploy-zendesk-get-account-key'
  ),
  learnMoreZendeskPrivateAppClassic: generateDocsUrl(
    '/?topic=assistant-deploy-zendesk#deploy-zendesk-add-private-app'
  ),
  learnMoreZendeskPrivateAppNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-zendesk#deploy-zendesk-add-private-app'
  ),
  learnMoreZendeskSecureClassic: generateDocsUrl(
    '/?topic=assistant-deploy-zendesk#deploy-zendesk-secure'
  ),
  learnMoreZendeskSecureNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-zendesk#deploy-zendesk-secure'
  ),
  learnMoreZendeskSecureAnonymous: generateDocsUrl(
    '/?topic=assistant-deploy-zendesk#deploy-zendesk-secure-anonymous'
  )
};
